import { Box, Typography } from '@material-ui/core';
import { StoreSaturationInfo } from '../../../store-saturation-info';

import makeClasses from './StoreStatusList.style';

import type { StoreId } from 'shared/domain';
import type { StoreStateByHDB } from 'business/highDemand';

export function StoreStatusList(props: Props) {
  const {
    title,
    stores,
    onClickStore,
    isActive = false,
    isInactive = false,
    isSuspended = false,
  } = props;

  const classes = makeClasses();

  return (
    <Box display='flex' flexDirection='column' gridGap='0.25rem'>
      <Typography className={classes.title}>{title}</Typography>
      {stores.map(store => (
        <StoreSaturationInfo
          key={`store-${store.id}`}
          storeName={store.name}
          variant={store.saturated}
          storeAddress={store.address}
          onClick={() => onClickStore(store.id)}
          isActiveStore={isActive}
          isInactive={isInactive}
          isSuspended={isSuspended}
          isTurbo={store.isTurbo}
        />
      ))}
    </Box>
  );
}

interface Props {
  title: string;
  stores: StoreStateByHDB[];
  onClickStore: (storeId: StoreId) => void;
  isActive?: boolean;
  isInactive?: boolean;
  isSuspended?: boolean;
}
